import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper"
import TMHFormBase from "../../components/TMHForm/TMHFormBase"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import TMHMemberPin from "../../components/TMHForm/TMHMemberPin"
import "./VerificationPage.css"
import useAuth from "../../core/Authentication/useAuth"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import { getUserInfo } from "../../core/APIService/apiService"


export default function VerificationPage() {
    let title = "Verification - The Movie House TV"
    let { id } = useParams()
    if (id === "id") {
        title = "Install Direct - The Movie House TV - Verification"
    }
    else if (id === "vrw") {
        title = "Visit Roku Website - The Movie House TV - Verification"
    }
    useTitle(title)

    const auth = useAuth()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [isVerified, setIsVerified] = useState(true)
    var pinNumber = "12345678"

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }

    if (auth.isLogged()) {
        pinNumber = auth.user.pin
    }

    useEffect(() => {
        if (!auth.isLogged()) {
            navigate("/login")
        }
        else {
            ReactGA.send("pageview")
        }
    }, [auth, navigate])

    async function handleSubmit(event) {
        setIsLoading(true)
        event.preventDefault();

        if (!auth.isLogged()) {
            await timeout(1000)
            setIsVerified(false)
            setIsLoading(false)
            return
        }

        const data = await getUserInfo(auth.user?.token)
        if (data) {
            if (data.status === 401) {
                auth.logout()
                navigate("/login")
                return
            }

            if (data.pin_verified) {
                navigate("/profile")
                return
            }
        }

        setIsVerified(false)
        setIsLoading(false)
    }

    return (
        <TMHBanner classOption="only-gradient">
            <TMHFormWrapper>
                <TMHFormBase onSubmit={handleSubmit} method="POST">
                    <div className="verification-page">
                        {
                            isVerified ?
                                <>
                                    <div className="last-step-badge">
                                        <span className="last-step-text">LAST STEP!</span>
                                    </div>
                                    <div className="content-text">
                                        <div className="title">Enter your PIN in The Movie House app and click the ‘Check my account is synced’ button below to verify</div>
                                    </div>
                                </>
                                :
                                <div className="content-text">
                                    <div className="title">We couldn’t verify your account</div>
                                    <div className="description">Please try entering your pin into your the Movie House app again.</div>
                                </div>
                        }
                        <div className="red-color">{errorText}</div>
                        <TMHMemberPin pinNumber={pinNumber ?? ""} />
                        <button type="submit" className="account-button">
                            <div className="account-button-text">Check my account is synced</div>
                        </button>

                        {!isVerified && <div className="last-description">If you cannot verify your account &#38; did not receive your pin number via email from The Movie House it’s possible your email is incorrect, don’t worry you
                            can <a href="/tmh/#/register" target="_blank">quickly start over here.</a>
                        </div>}
                    </div>
                </TMHFormBase>
                {isLoading && <TMHLoader />}
            </TMHFormWrapper>
        </TMHBanner>
    )
}
